import { render } from "./TextBot.vue?vue&type=template&id=d13077f6&ts=true"
import script from "./TextBot.vue?vue&type=script&lang=ts"
export * from "./TextBot.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/root/dev.front.widget/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__